<template>
  <div class="register-from-invite-form">
    <b-alert variant="danger" :show="hasSubmitError" dismissible>
      {{$t('registerFromInviteForm.errorMessage')}}
    </b-alert>

    <p>{{$t('registerFromInviteForm.info', {appName: $t('appName')})}}</p>

    <b-form novalidate @submit.stop.prevent="register">

      <b-form-group
        id="password-input-group"
        :label="$t('registerFromInviteForm.passwordLabel')"
        label-for="password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="password-input"
          ref="password"
          name="password"
          v-model="password"
          v-validate="{required: true, min: 6}"
          :state="validateState('password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('registerFromInviteForm.passwordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="confirm-password-input-group"
        :label="$t('registerFromInviteForm.confirmPasswordLabel')"
        label-for="confirm-password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="confirm-password-input"
          name="confirm-password"
          v-model="confirmPassword"
          v-validate="{required: true, confirmed: 'password'}"
          :state="validateState('confirm-password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('registerFromInviteForm.confirmPasswordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col>
          <loading-button
            :text="$t('registerFromInviteForm.btnText')"
            :loading-text="$t('registerFromInviteForm.btnLoadingText')"
            variant="primary"
            :loading=submitting
            type="submit"
            :disabled="veeErrors.any()"
          />
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import FormValidation from '../../mixins/FormValidation';

  export default {
    mixins: [FormValidation],
    computed: mapState({
      user: state => state.account.user,
    }),
    data() {
      return {
        userId: this.$route.params.userId,
        inviteCode: this.$route.params.inviteCode,
        submitting: false,
        password: '',
        confirmPassword: '',
        hasSubmitError: false,
      };
    },
    methods: {
      register() {
        this.$validator.validateAll()
          .then((result) => {
            if (!result) {
              return;
            }
            this.submitting = true;
            this.$store.dispatch('account/completeInvite', {
              userId: this.userId,
              inviteCode: this.inviteCode,
              password: this.password,
            }).then(() => {
              this.hasSubmitError = false;
              this.$toasted.success(this.$t('registerFromInviteForm.registerMessage', { appName: this.$t('appName'), name: this.user.firstName }), {
                icon: 'star',
              });
              this.$router.push('/');
            }).catch(() => {
              this.hasSubmitError = true;
            }).finally(() => {
              this.submitting = false;
            });
          });
      },
    },
  };
</script>

<style scoped>

</style>
